/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from "react";
import { Button } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useRouter } from "next/navigation";
import { FeaturedBrand } from "@/types/General";


function HomeFeaturedBrands({ brands = [] }: { brands?: FeaturedBrand[] }) {
  const router = useRouter();
  type Slider = any;
  const sliderRef = useRef<Slider | null>(null);
  const settings2 = {
    infinite: brands.length > 8,
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: brands.length > 4,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: brands.length > 2,
        },
      },
    ],
  };

  return (
    <>
      <section className="home_brands_sc product_sc">
        <div className="container">
          <div className="s_head flex hd_4">
            <h2>Featured Brands</h2>
            <div className="rt">
              <Button
                variant="outlined"
                size="small"
                onClick={() => router.push("/product/product-category?type=featured_brands")}
              >
                More <KeyboardArrowRightIcon />
              </Button>
            </div>
          </div>

          <Slider ref={sliderRef} {...settings2} className="brand_slider">
            {brands?.map((brand, index) => (
              <div
                key={`home-featured-brand-${brand?.id || 'no-id'}-${index}`}
                onClick={() => {
                  const hasAllKeys = brand?.banner_links?.every(
                    (link) => link?.linkable_id && link?.linkable_type && link?.type
                  );

                  if (hasAllKeys) {
                    if (brand?.type === "brand") {
                      router.push(
                        `/product/product-category?brandIds=${brand?.banner_links
                          ?.map((link) => link?.linkable_id)
                          .join(",")}`
                      );
                    } else if (brand.type === "category") {
                      router.push(
                        `/product/product-category?categoryIds=${brand?.id}&type=featured_brands`
                      );
                    } else {
                      router.push("/product/product-category?type=recommended");
                    }
                  } else {
                    router.push("/product/product-category?type=recommended");
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                <div className="brand_info" style={{ height: '100%' }}>
                  <figure className="bransssd_bg">
                    <img src={brand.image} alt={brand.title || "banner"} style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
                  </figure>
                  {/* {brand?.image && (
                    <figure className="brand_logo">
                      <img src={brand?.image} alt="Brand Logo" />
                    </figure>
                  )} */}
                  {/* {brand?.description && <h3>{brand?.description}</h3>} */}
                  {/* <p>{brand.title !== "FeaturedBrands" && brand.title !== "Featured Brands" ? brand.title : brand.description}</p> */}
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
}

export default HomeFeaturedBrands;
